<template>
  <div class="regionSelectBackground">
    <img
      v-if="cancelable"
      @click="cancel()"
      class="regionCloseBtn"
      src="../assets/Btn_Close.png"
      alt=""
    />
    <p class="regionSelectTitle">
      {{ langlist[$store.state.lang]["로그인할 위치를 선택하세요."] }}
    </p>
    <div class="regionPanel">
      <div class="regionPanelTitle">
        <p class="regionPanelTitleText">
          {{ langlist[$store.state.lang]["regionListLabel"] }}
        </p>
      </div>
      <div class="regionPanelContent">
        <div
          class="regionList"
          role="radiogroup"
          :aria-label="langlist[$store.state.lang]['regionListLabel']"
        >
          <div
            class="regionElement"
            :class="{ regionElementOn: j.region_code === regionCode }"
            v-for="(j, i) in regions"
            :key="i"
            role="radio"
            tabindex="0"
            :aria-checked="j.region_code === regionCode"
            @click="selectRegion(j)"
            @keydown.enter.prevent="selectRegion(j)"
            @keydown.space.prevent="selectRegion(j)"
          >
            <div
              class="regionRadio"
              :class="{ regionRadioOn: j.region_code === regionCode }"
            ></div>
            <p class="regionName">
              {{ regionLabel(j, $store.state.lang) }}
            </p>
          </div>
        </div>
        <div
          @click="setregionCheck()"
          class="regionOkBtn"
          :class="{ regionOkBtnDisabled: !regionCode }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { regionList } from "@/api";
import { saveRegion, regionLabel } from "@/store/region";
import { ko, vt, en, zh, ja } from "@/_translate/translate.js";
import { applyJosa } from "@/_translate/josa.js";

export default {
  props: {
    // 저장된 국가가 없는 최초 진입에서는 닫을 수 없다
    cancelable: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      regions: [],
      regionCode: "",
      langlist: {
        ko,
        vt,
        en,
        zh,
        ja,
      },
    };
  },
  async created() {
    this.regionCode = this.current ? this.current.region_code : "";

    await this.getRegionList();

    window.addEventListener("regionCheck", this.setregion);
  },
  beforeDestroy() {
    window.removeEventListener("regionCheck", this.setregion);

    // 확인 창을 띄운 채로 패널이 사라지면 다음 진입에서 그대로 떠 있게 된다
    this.$store.state.regionCheck = {
      status: false,
      type: "",
      text: "",
      location: "",
    };
  },
  methods: {
    regionLabel,
    async getRegionList() {
      try {
        const res = (await regionList()).data;

        this.regions = res.data || res;
      } catch (e) {
        this.regions = [];

        const event = new CustomEvent("error", {
          detail: {
            errortext:
              this.langlist[this.$store.state.lang][
                "국가 목록을 불러오지 못했습니다."
              ],
          },
        });
        window.dispatchEvent(event);
      }
    },
    selectRegion(region) {
      if (region.region_code === this.regionCode) {
        this.regionCode = "";
      } else {
        this.regionCode = region.region_code;
      }
    },
    setregionCheck() {
      const region = this.regions.find(
        (el) => el.region_code === this.regionCode
      );

      if (!region) {
        return;
      }

      const name = regionLabel(region, this.$store.state.lang);

      this.$store.state.regionCheck = {
        status: true,
        type: "first",
        text: applyJosa(
          this.langlist[this.$store.state.lang]["국가선택체크모달"].replace(
            /{location}/g,
            name
          )
        ),
        location: name,
      };
    },
    setregion() {
      const region = this.regions.find(
        (el) => el.region_code === this.regionCode
      );

      if (!region) {
        return;
      }

      saveRegion(region);

      // 국가가 바뀌면 webgl 을 다시 받으므로 로드 완료 상태를 초기화한다
      window.dispatchEvent(new CustomEvent("loadComplete", { detail: false }));

      this.$store.state.region = region;
      this.$emit("setregion", region);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
/* 피그마 Login_Area 1300x586 을 800 기준으로 축소(x0.615) */
.regionSelectBackground {
  /* background-color: rgba(182, 211, 255, 0.9); */
  background-image: url("../assets/Books_school_search_back.png");
  /* 원본 1300x587(비율 2.215)을 800x400(비율 2.0) 박스에 채운다.
     100%(=100% auto)면 높이가 361px로 모자라 아래쪽에 이미지가 반복된다 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* border: 1px solid #8098d7; */
  width: 800px;
  height: 400px;
  border-radius: 32px;
  text-align: center;
  overflow: hidden;
  position: relative;
}

.regionCloseBtn {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 40px;
  cursor: pointer;
  z-index: 1;
}

.regionCloseBtn:hover {
  filter: brightness(0.8);
}

.regionSelectTitle {
  font-family: cookiebold;
  font-size: 28px;
  color: #0d1e52;
  padding-top: 25px;
  margin-bottom: 20px;
}

.regionPanel {
  width: 756px;
  margin-left: 22px;
  border-radius: 12px;
  overflow: hidden;
}

.regionPanelTitle {
  width: 100%;
  height: 46px;
  background-color: #607ccd;
  text-align: left;
}

.regionPanelTitleText {
  font-family: notosans;
  font-size: 20px;
  color: #ffffff;
  margin-left: 25px;
  padding-top: 8px;
}

.regionPanelContent {
  width: 100%;
  height: 246px;
  background-color: #f4fbff;
}

.regionList {
  width: 682px;
  margin-left: 37px;
  height: 158px;
  padding-top: 8px;
  overflow-y: auto;
  text-align: left;
}

/* 행 전체가 클릭 영역이며 hover/선택 상태를 배경으로 표시한다 */
/* 높이는 학교 검색 패널의 결과 행(52px)과 동일하게 맞춘다 */
.regionElement {
  height: 52px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: -8px;
  padding: 0 8px;
  transition: background-color 0.15s ease;
}

.regionElement:hover {
  background-color: rgba(96, 124, 205, 0.12);
}

.regionElement:focus-visible {
  outline: 2px solid #607ccd;
  outline-offset: -2px;
}

.regionElementOn {
  background-color: rgba(96, 124, 205, 0.18);
}

.regionRadio {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  border: 2px solid rgba(13, 30, 82, 0.45);
  background-color: #ffffff;
  box-sizing: border-box;
  flex: none;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.regionElement:hover .regionRadio {
  border-color: #607ccd;
}

.regionRadioOn,
.regionElement:hover .regionRadioOn {
  border-color: #0d1e52;
  background-color: #0d1e52;
  box-shadow: inset 0 0 0 3px #ffffff;
}

.regionName {
  font-family: notosansregular;
  font-size: 21px;
  color: #0d1e52;
  margin-left: 11px;
  margin-bottom: 0;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.regionElementOn .regionName {
  font-family: notosansmedium;
}

/* 피그마 스크롤바 (트랙 흰색 + #607ccd 썸) */
.regionList::-webkit-scrollbar {
  width: 12px;
}

.regionList::-webkit-scrollbar-track {
  background-color: #ffffff;
  border: 1px solid #607ccd;
  border-radius: 9px;
}

.regionList::-webkit-scrollbar-thumb {
  background-color: #607ccd;
  border-radius: 9px;
}

.regionOkBtn {
  background-image: url("../assets/Btn_OK.png");
  background-size: 100%;
  background-repeat: no-repeat;
  width: 180px;
  height: 71px;
  margin: 8px auto 0;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.regionOkBtn:hover {
  filter: brightness(0.8);
}

/* 선택 전에는 눌러도 동작하지 않으므로 비활성으로 보이게 한다 */
.regionOkBtnDisabled,
.regionOkBtnDisabled:hover {
  filter: grayscale(0.8) opacity(0.45);
  cursor: default;
}
</style>
